import React from 'react';
import {JAVASCRIPT_VOID} from 'constants/config';

interface IAnchorProps {
  url?: string;
  targetType?: string;
  title?: string;
  classNaming?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  children?: any;
}

/**
 * a 태그 공용 컴포넌트
 */

const Anchor = ({
  url,
  targetType,
  title,
  classNaming,
  onClick,
  children,
}: IAnchorProps) => {
  // const handleClick = (
  //     e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  // ) => {
  //     e.preventDefault();
  //     window.open(url, targetType);
  // };

  return url !== '' ? (
    <a
      href={url}
      target={targetType}
      title={title}
      rel='noopener noreferrer'
      className={classNaming}>
      {children}
    </a>
  ) : (
    <a
      href={JAVASCRIPT_VOID}
      onClick={onClick}
      title={title}
      className={classNaming}>
      {children}
    </a>
  );
};

Anchor.defaultProps = {
  url: '',
  targetType: '',
  title: '',
  classNaming: '',
};

export default Anchor;
